export default __webpack_public_path__ + "static/A-701caa0ab727a72c9c38bb3adbd5180a.png";